import { use, useLayoutEffect } from 'react'

import { PageTitleContext } from '../state/PageTitleProvider'

export const usePageTitle = (title: string | undefined): void => {
  const { setPageTitle } = use(PageTitleContext)

  useLayoutEffect(() => {
    if (title) {
      setPageTitle(title)
    }
    return () => setPageTitle('')
  }, [title, setPageTitle])
}
